var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":""}},[_c('h5',[_vm._v(_vm._s(_vm.computedLoadingText))]),_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }